
















import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { LineLayer } from '@/model/document2/page/surface/design/layer/lineLayer';
import { SVGPathData, encodeSVGPath } from 'svg-pathdata';
import { UserAgentHelper } from '@/helper/userAgentHelper';

@Component({
    components: {
    },
})
export default class LineLayerDrawer extends Vue {
  
    @Prop() private layer!: LineLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    private get isElectronWin()
    {
        return UserAgentHelper.isElectron() && UserAgentHelper.getOS() != "MacOS";
    }

    private get boundsX()
    {
        return this.layer.getBoundingRect().x * this.scale + this.offsetX;
    }

    private get boundsY()
    {
        return this.layer.getBoundingRect().y * this.scale + this.offsetY;
    }

    private get boundsWidth()
    {
        return Math.max(this.layer.getBoundingRect().width * this.scale, 1);
    }

    private get boundsHeight()
    {
        return Math.max(this.layer.getBoundingRect().height * this.scale, 1);
    }

    private get x1()
    {
        return this.layer.startX * this.scale + this.offsetX;
    }
    
    private get y1()
    {
        return this.layer.startY * this.scale + this.offsetY;
    }

    private get x2()
    {
        return this.layer.endX * this.scale + this.offsetX;
    }

    private get y2()
    {
        return this.layer.endY * this.scale + this.offsetY;
    }

    private get strokeColor()
    {
        var r = this.layer.strokeColor.r;
        var g = this.layer.strokeColor.g;
        var b = this.layer.strokeColor.b;

        return "rgb(" + r + "," + g + "," + b + ")";
    }

    private get opacity()
    {
        return this.layer.opacity / 100;
    }

    private get strokeWidth()
    {
        return this.layer.strokeWidth * this.scale;
    }

    private get strokeDasharray()
    {
        var dash = "";

        if(this.layer.strokeType == 1)
        {
            // 点線
            // 点線の長さ = 線幅
            // 空白 = 線幅
            dash = this.strokeWidth + "," + this.strokeWidth;
        }
        else if(this.layer.strokeType == 2)
        {
            // 点線(広い)
            // 点線の長さ = 線幅
            // 空白 = 線幅 * 4
            dash = this.strokeWidth + "," + (this.strokeWidth * 4);
        }
        else if(this.layer.strokeType == 3)
        {
            // 破線
            // 点線の長さ = 線幅 * 5
            // 空白 = 線幅 * 2
            dash = (this.strokeWidth * 5) + "," + (this.strokeWidth * 2);
        }
        else if(this.layer.strokeType == 4)
        {
            // 破線 + 点線
            dash = (this.strokeWidth * 4) + "," + this.strokeWidth + "," + this.strokeWidth + "," + this.strokeWidth;
        }

        return dash;
    }

    private get startVisible()
    {
        return this.layer.startType != 0;
    }

    private get startPath()
    {
        var tempPath = "";
        var startWidth = this.layer.startWidth * this.scale;
        if(this.layer.startType == 1)
        {
            // 単線矢印
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: startWidth, y: -startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth, y: startWidth / 2 },
                ]
            );
        }
        else if(this.layer.startType == 2)
        {
            // 塗りつぶし矢印
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: startWidth, y: -startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth, y: startWidth / 2 },
                    { type: SVGPathData.CLOSE_PATH }
                ]
            );
        }
        else if(this.layer.startType == 3)
        {
            // 矢じり
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: startWidth, y: -startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth, y: startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth / 2, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }
                ]
            );
        }
        else if(this.layer.startType == 4)
        {
            // 丸
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: 0, y: 0 },
                    { type: SVGPathData.ARC, relative: false, rX: startWidth / 2, rY: startWidth / 2, xRot: 0, lArcFlag: 0, sweepFlag: 1, x: startWidth, y: 0 },
                    { type: SVGPathData.ARC, relative: false, rX: startWidth / 2, rY: startWidth / 2, xRot: 0, lArcFlag: 0, sweepFlag: 1, x: 0, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }   
                ]
            );
        }
        else if(this.layer.startType == 5)
        {
            // ひし形
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: startWidth / 2 - this.strokeWidth, y: -startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth / 2 - this.strokeWidth, y: startWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: startWidth - this.strokeWidth, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }   
                ]
            );
        }

        if(tempPath == "") { return ""; }

        var tempData = new SVGPathData(tempPath);
        var rad = this.layer.rotate * Math.PI / 180;
        tempData.rotate(rad);
        tempData.translate(this.x1, this.y1);
        return tempData.encode();
    }

    private get startStrokeColor()
    {
        var color = "none";
        if(this.layer.startType == 1)
        {
            color = this.strokeColor;
        }
        return color;
    }

    private get startFillColor()
    {
        var color = "none";
        if(this.layer.startType == 2 || this.layer.startType == 3 || this.layer.startType == 4 || this.layer.startType == 5)
        {
            color = this.strokeColor;
        }
        return color;
    }

    private get endVisible()
    {
        return this.layer.endType != 0;
    }

    private get endPath()
    {
        var tempPath = "";
        var endWidth = this.layer.endWidth * this.scale;
        if(this.layer.endType == 1)
        {
            // 単線矢印
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: -endWidth, y: -endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth, y: endWidth / 2 },
                ]
            );
        }
        else if(this.layer.endType == 2)
        {
            // 塗りつぶし矢印
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: -endWidth, y: -endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth, y: endWidth / 2 },
                    { type: SVGPathData.CLOSE_PATH }
                ]
            );
        }
        else if(this.layer.endType == 3)
        {
            // 矢じり
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: -endWidth, y: -endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth, y: endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth / 2, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }
                ]
            );
        }
        else if(this.layer.endType == 4)
        {
            // 丸
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: 0, y: 0 },
                    { type: SVGPathData.ARC, relative: false, rX: endWidth / 2, rY: endWidth / 2, xRot: 0, lArcFlag: 0, sweepFlag: 1, x: -endWidth, y: 0 },
                    { type: SVGPathData.ARC, relative: false, rX: endWidth / 2, rY: endWidth / 2, xRot: 0, lArcFlag: 0, sweepFlag: 1, x: 0, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }   
                ]
            );
        }
        else if(this.layer.endType == 5)
        {
            // ひし形
            tempPath = encodeSVGPath(
                [
                    { type: SVGPathData.MOVE_TO, relative: false, x: -endWidth / 2 + this.strokeWidth, y: -endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: this.strokeWidth, y: 0 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth / 2 + this.strokeWidth, y: endWidth / 2 },
                    { type: SVGPathData.LINE_TO, relative: false, x: -endWidth + this.strokeWidth, y: 0 },
                    { type: SVGPathData.CLOSE_PATH }   
                ]
            );
        }

        if(tempPath == "") { return ""; }

        var tempData = new SVGPathData(tempPath);
        var rad = this.layer.rotate * Math.PI / 180;
        tempData.rotate(rad);
        tempData.translate(this.x2, this.y2);
        return tempData.encode();
    }

    private get endStrokeColor()
    {
        var color = "none";
        if(this.layer.endType == 1)
        {
            color = this.strokeColor;
        }
        return color;
    }

    private get endFillColor()
    {
        var color = "none";
        if(this.layer.endType == 2 || this.layer.endType == 3 || this.layer.endType == 4 || this.layer.endType == 5)
        {
            color = this.strokeColor;
        }
        return color;
    }

    private onMouseDown()
    {
        this.layer.isTouched = true;
    }

    private onMouseUp()
    {
        this.layer.isTouched = false;
    }
}
